import { render, staticRenderFns } from "./excavate_check.vue?vue&type=template&id=6b834e20"
import script from "./excavate_check.vue?vue&type=script&lang=js"
export * from "./excavate_check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports